import getters from './getters';
import mutations from './mutations';

const state = {
  head: {},
  header: [],
  clientContext: [],
  megaMenu: [],
  footer: []

};

export default {
  state,
  getters,
  mutations
};
